
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Table } from "../../../Widgets/Table/Table.js";
import { roleDisplayName } from "../../../Common.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { createObj, equals, int32ToString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toArray, ofArray, empty, filter, length } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { RoleId__get_unwrap } from "../../../Shared/Shared.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InformationAlert } from "../../../Components/Alert.js";
import { Button } from "../../../Components/Button.js";
import Shipment_Add from "../../../../public/assets/icons/Shipment_Add.svg";
import { Skeleton } from "../../../Components/Skeleton.js";

function RolesTable(props) {
    const t = useTranslation()[0];
    return createElement(Table, {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (role_1) => (new CellContent(0, [roleDisplayName(t, role_1)])), "text", "text"), new ColumnDefinition$1("kind", "", t("settings.roles.kind"), (role_2) => ((role_2.SystemKey == null) ? (new CellContent(0, [t("settings.roles.custom_role")])) : (new CellContent(0, [t("settings.roles.system_role")]))), "select", "text"), new ColumnDefinition$1("assignedUsers", "", t("settings.roles.assigned_users"), (role_3) => (new CellContent(0, [int32ToString(length(filter((assignment) => equals(assignment.RoleId, role_3.Id), props.Assignments)))])), "none", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(role_4) => RouterModule_encodeParts(ofArray(["settings", "roles", RoleId__get_unwrap(role_4.Id)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "roles-table",
        TableRows: toArray(props.Roles),
    });
}

export function RolesOverviewView() {
    let elems_1, elems, Label;
    const patternInput = useTranslation();
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined)[0];
    const matchValue = state_1.Roles;
    const matchValue_1 = state_1.Assignments;
    let matchResult, assignments, roles;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            assignments = matchValue_1.fields[0];
            roles = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(InformationAlert, {
                Label: "settings.roles.description",
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems = [createElement(Button, (Label = patternInput[0]("settings.roles.new_role"), {
                ComponentState: "enabled",
                Icon: Shipment_Add(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["settings", "roles", "new"]), 1, 1);
                },
                TestId: "new-role-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(RolesTable, {
                Assignments: assignments,
                Roles: roles,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

